import { getIssueKey } from '@atlassian/jira-router-resources-utils/src/utils/get-issue-key/index.tsx';
import type { RouterDataContext, ResourceStoreContext } from '@atlassian/react-resource-router';
// eslint-disable-next-line jira/import-whitelist
import { prefetchedRemoteDataManager } from '@atlassian/jira-issue-fetch-services/src/services/issue-view-remote-data/prefetched-issue-view-remote-data-manager.tsx';

const getData = async ({ match }: RouterDataContext, _storeContext: ResourceStoreContext) => {
	const issueKey = getIssueKey(match);

	if (!issueKey) {
		return null;
	}

	prefetchedRemoteDataManager.prefetch(issueKey);
	return null;
};

export default getData;
